export function getEmbedUrl(url) {
    if (!url) return null;
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|live\/|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
    if (url.includes("twitch.tv/") && !url.includes("player.twitch.tv")) {
        const channel = url.split("twitch.tv/")[1]?.split(/[/?]/)[0];
        if (channel) return `https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}`;
    }
    return url;
}
